var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1333 19.2002C22.7224 19.2002 23.2 18.7226 23.2 18.1335C23.2 17.5444 22.7224 17.0668 22.1333 17.0668C21.5442 17.0668 21.0667 17.5444 21.0667 18.1335C21.0667 18.7226 21.5442 19.2002 22.1333 19.2002Z",
    fill: "currentCOlor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5.3335H7.2C5.43269 5.3335 4 6.76618 4 8.5335V23.4668C4 25.2341 5.43269 26.6668 7.2 26.6668H24.2667C26.034 26.6668 27.4667 25.2341 27.4667 23.4668V12.8002C27.4667 11.0329 26.034 9.60016 24.2667 9.60016H23.2V8.5335C23.2 6.76618 21.7673 5.3335 20 5.3335ZM7.2 7.46683C6.6109 7.46683 6.13333 7.94439 6.13333 8.5335C6.13333 9.1226 6.6109 9.60016 7.2 9.60016H21.0667V8.5335C21.0667 7.94439 20.5891 7.46683 20 7.46683H7.2ZM7.2 11.7335C6.82599 11.7335 6.46696 11.6693 6.13333 11.5514V23.4668C6.13333 24.0559 6.6109 24.5335 7.2 24.5335H24.2667C24.8558 24.5335 25.3333 24.0559 25.3333 23.4668V12.8002C25.3333 12.2111 24.8558 11.7335 24.2667 11.7335H7.2Z",
    fill: "currentCOlor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWallet);
export default __webpack_public_path__ + "static/media/new-wallet.26d573b5b70441d06ba31676d558b2f7.svg";
export { ForwardRef as ReactComponent };